<script setup>
import { classItems } from '../../config/pageData.js';
</script>

<template>
  <section class="m-sec">
    <h2 class="m-title">課堂實錄 · 授課現場</h2>
    <p class="m-sub">線下實體課堂真實記錄——面對面授課、逐個拆解，唔係得個講字。</p>
    <div class="m-gallery">
      <figure
        v-for="(item, i) in classItems"
        :key="i"
        class="m-gallery-fig"
      >
        <img
          :src="item.image"
          :alt="item.caption"
          class="m-gallery-img"
          loading="lazy"
        />
        <figcaption class="m-gallery-cap">{{ item.caption }}</figcaption>
      </figure>
    </div>
  </section>
</template>

<style scoped lang="scss">
.m-sec {
  padding: 96px 32px;
}

.m-title {
  font-size: 44px;
  font-weight: 700;
  line-height: 1.4;
  text-align: center;
  color: #16241d;
  letter-spacing: 1px;
}

.m-sub {
  text-align: center;
  color: #6f6a5c;
  font-size: 26px;
  margin-top: 18px;
}

.m-gallery {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 22px;
  margin-top: 44px;
}

.m-gallery-fig {
  margin: 0;
}

.m-gallery-img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  border-radius: 14px;
  display: block;
}

.m-gallery-cap {
  margin-top: 10px;
  text-align: center;
  font-size: 22px;
  color: #6f6a5c;
  letter-spacing: 2px;
}
</style>
